const xor32 = (a, b) => a ^ b;
export default xor32;
